<template>
  <div>
    <!-- <teleport :to="body"> -->
    <div class="overlay">
      <div class="overlay-right">
        <div class="overlay-right-header">
          <div style="font-weight: bold">任务详情</div>
          <div @click="onClose" style="cursor: pointer">
            <BaseSvg
              style="width: 20px; height: 20px"
              iconClass="close"
            ></BaseSvg>
          </div>
        </div>
        <div
          :style="auditShow ? 'height: calc(100vh - 160px)' : 'height: 100%'"
          class="overlay-right-main"
        >
          <div>
            <div class="rectitle" v-if="isUnqualified">
              <div class="rectitle-text">
                <span style="font-size: 16px; color: #ea0d0d">不可结算</span>
                <span style="font-size: 14px">
                  数据检测不合格，系统已自动拦截
                </span>
              </div>
            </div>
            <!-- 查询结果包含 重复图片的话 展示-->
            <BaseRow
              v-if="isPicRepeat"
              style="padding: 5px 5px; text-align: left"
            >
              <span>
                <i class="el-icon-warning" style="color: #ff4949"></i>
                <span style="font-weight: bold">图片查重提示：</span>
                <span style="color: #ff4949">*</span>
                标记任务记录内提交的图存在重复,
                <BaseButton
                  type="text"
                  @click="repeatPickurePerview"
                  style="color: #409eff; text-decoration: underline"
                >
                  点击查看
                </BaseButton>
              </span>
            </BaseRow>
          </div>
          <div class="overlay-right-main__reuqire">
            <div class="overlay-right-main__reuqire-item">
              <div>终端服务人员：</div>
              <div>
                {{ taskDetail?.username || '-' }}
                <span style="margin: 0 1px"></span>
                {{ taskDetail?.phone || '-' }}
              </div>
            </div>
            <div class="overlay-right-main__reuqire-item">
              <div>任务提交时间：</div>
              <div>{{ formatter.date(taskDetail?.editStatusAt) }}</div>
            </div>
            <div
              v-if="projectType === 19"
              class="overlay-right-main__reuqire-item"
            >
              <div>结算金额：</div>
              <div>{{ formatter.fen2yuan(taskDetail?.price) }}</div>
            </div>
          </div>
          <div class="overlay-right-main__info">
            <div class="overlay-right-main__info-item">
              <BaseButton
                type="primary"
                @click="showPreviewName = 'informationShow'"
                v-if="projectType === 21"
              >
                查看资讯
              </BaseButton>
            </div>
            <!-- 智能辅助审核结果：仅服务商显示 -->
            <div v-if="isAsp && aiConclusionData" class="ai-verdict-panel">
              <div class="ai-vp-head">
                <span class="ai-vp-head-icon">🤖</span>
                <span class="ai-vp-head-title">智能辅助审核结果</span>
                <span class="ai-vp-head-spacer"></span>
                <span class="ai-vp-conclusion">
                  {{ summaryTheme.icon }} {{ summaryTheme.label }}
                </span>
              </div>
              <div class="ai-vp-body">
                <div class="ai-stage-row">
                  <div v-if="initTheme.label" class="ai-stage">
                    <div class="ai-stage-t">① 单条审核</div>
                    <span class="ai-verdict" :class="initTheme.cls">
                      <span class="ai-verdict-icon">{{ initTheme.icon }}</span>
                      {{ initTheme.label }}
                    </span>
                    <div class="ai-stage-sum">{{ aiInitSummary }}</div>
                    <div class="ai-stage-time">
                      审核时间：{{
                        aiConclusionData?.aspAuditAt
                          ? formatter.date(aiConclusionData.aspAuditAt)
                          : '-'
                      }}
                    </div>
                  </div>
                  <div v-if="finalBatchPill.label" class="ai-stage">
                    <div class="ai-stage-t">② 批量审核</div>
                    <span class="aia-pill" :class="finalBatchPill.cls">
                      {{ finalBatchPill.label }}
                    </span>
                    <div class="ai-stage-sum">{{ aiFinalSummary }}</div>
                    <div class="ai-stage-time">
                      审核时间：{{
                        aiConclusionData?.ossAuditAt
                          ? formatter.date(aiConclusionData.ossAuditAt)
                          : '-'
                      }}
                    </div>
                  </div>
                </div>

                <!-- 智能结果不准确，产品让隐藏 -->
                <!-- <div class="ai-vp-section-title">📌 主要理由</div>
                <div class="ai-reason-list">
                  <div
                    v-for="(r, i) in aiReasonList"
                    :key="i"
                    class="ai-reason"
                  >
                    <span class="ai-reason-code">
                      R{{ String(i + 1).padStart(2, '0') }}
                    </span>
                    <div>
                      <div class="ai-reason-title">{{ r.title }}</div>
                      <div v-if="r.desc" class="ai-reason-desc">
                        {{ r.desc }}
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>

            <p style="margin: 24px 0">问卷详情</p>
            <div>
              <component
                :is="compNames"
                :isShowMapHandleBtn="isShowMapHandleBtn"
                :questionInfo="questionDetailInfo"
                @changeImgUrl="onChangeImgUrl"
                @mapRefresh="onMapRefresh"
                @diffMap="onDiffMap"
              ></component>
            </div>
          </div>
        </div>
        <div
          v-if="auditShow"
          v-resource="['任务记录_审核任务']"
          class="overlay-right-footer"
        >
          <div>
            <BaseButton
              :disabled="
                taskDetail?.buttonOnOff === 0 || taskDetail?.buttonOnOff === 2
              "
              @click="onAudit(2)"
              plain
            >
              通过
            </BaseButton>
            <BaseButton
              :disabled="taskDetail?.buttonOnOff === 0"
              type="default"
              @click="onAudit(3)"
              plain
            >
              不通过
            </BaseButton>
          </div>
        </div>
      </div>
      <div class="overlay-left">
        <CPreview
          v-if="showPreviewName === 'informationShow'"
          :projectType="props.projectType"
          :informationId="taskDetail?.informationId"
          :projectId="props.projectId"
          :taskId="props.id"
        ></CPreview>
        <BaseImageViewer
          v-if="showPreviewName === 'imgViewerShow'"
          :previewTeleported="true"
          :infinite="true"
          :preview-src-list="picList"
          :initial-index="showIndex"
          :hide-close="true"
        ></BaseImageViewer>
        <DeefMap
          v-if="showPreviewName === 'deefMapShow'"
          :projectType="props.projectType"
          :projectId="props.projectId"
          :taskRecordId="props.id"
          :dataState="taskDetail?.dataState"
        ></DeefMap>
      </div>
    </div>
    <!-- </teleport> -->
  </div>
</template>
<script lang="tsx" setup>
import { watch, ref, nextTick, computed, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import {
  AI_AUDIT_RESULT,
  AiAuditResult
} from '@/common/constants/intelligent-audit';
import { BaseSvg } from '@/components/base/base-svg/index';
import { useTaskAudit } from '../hooks/useTaskAudit';
import {
  BaseButton,
  BaseImageViewer,
  BaseRow,
  createDialog
} from 'xrk-components';
import { questionDetailComps } from '../components/question-detail-comps';
import { ProjectType } from '../types';
import { formatter } from '@/utils';
import {
  taskRecordUpdateMap,
  selectSimilartList,
  taskRecordDetail
} from '../data-source/apis';
import DeefMap from './deef-map.vue';
import CPreview from './c-preview.vue';
import RepeatPickure from './repeat-pickure.vue';

import appStore from '@/store';

const props = withDefaults(
  defineProps<{
    id: number;
    dataState: number;
    projectId: number;
    projectType: ProjectType;
    searchVal: any;
    remove?: () => void;
    canAudit: boolean;
    isShowMapHandleBtn?: boolean; // 是否显示地图操作按钮
  }>(),
  {
    isShowMapHandleBtn: true
  }
);

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);
/**
 * 是否是工业
 */
// const isIndustry = computed(() => defaultUserFnCode.value === 1);

/* ------------ 智能综合审核结论（仅服务商显示） ------------ */
const aiConclusionData = computed<any>(
  () => taskDetail.value?.aiAuditConclusion
);
const AI_RESULT_META: Record<
  number,
  {
    label: string;
    icon: string;
    cls: 'ai-pass' | 'ai-warn' | 'ai-reject';
    pillCls: 'pass' | 'review' | 'reject';
  }
> = {
  [AiAuditResult.Failed]: {
    label: '审核失败',
    icon: '!',
    cls: 'ai-warn',
    pillCls: 'reject'
  },
  [AiAuditResult.Pass]: {
    label: AI_AUDIT_RESULT[AiAuditResult.Pass].label,
    icon: '✓',
    cls: 'ai-pass',
    pillCls: 'pass'
  },
  [AiAuditResult.Reject]: {
    label: AI_AUDIT_RESULT[AiAuditResult.Reject].label,
    icon: '✕',
    cls: 'ai-reject',
    pillCls: 'reject'
  },
  [AiAuditResult.Doubt]: {
    label: AI_AUDIT_RESULT[AiAuditResult.Doubt].label,
    icon: '!',
    cls: 'ai-warn',
    pillCls: 'review'
  }
};
const FALLBACK_THEME = { label: '', icon: '!', cls: 'ai-warn' as const };
const initTheme = computed(
  () =>
    AI_RESULT_META[aiConclusionData.value?.aspStatus as number] ||
    FALLBACK_THEME
);
const summaryTheme = computed(
  () =>
    AI_RESULT_META[aiConclusionData.value?.overallStatus as number] ||
    FALLBACK_THEME
);
const finalBatchPill = computed(() => {
  const meta = AI_RESULT_META[aiConclusionData.value?.ossStatus as number];
  if (!meta) return { cls: 'reject' as const, label: '' };
  return { cls: meta.pillCls, label: meta.label };
});
const aiInitSummary = computed(() => aiConclusionData.value?.aspOpinion || '—');
const aiFinalSummary = computed(
  () => aiConclusionData.value?.ossOpinion || '—'
);
const _aiReasonList = computed<Array<{ title: string; desc?: string }>>(() => {
  const list = (aiConclusionData.value?.reasons || []) as Array<{
    riskTitle?: string;
    riskContent?: string;
  }>;
  return list.map(r => ({ title: r.riskTitle || '—', desc: r.riskContent }));
});

const isUnqualified = computed(
  () =>
    taskDetail.value?.dataState == 0 &&
    taskDetail.value?.isOverdue == 0 &&
    +taskDetail.value?.superviseStatus !== 1
); // 数据检测不合格，系统拦截);

const repitImgIds = ref([]); // 重复图片id集合
const repitImgList = ref({}); // 重复图片

const showPreviewName = ref(
  props.projectType === 17 ? 'informationShow' : 'imgViewerShow'
);

const isPicRepeat = computed(() => {
  return !!Object.keys(repitImgIds.value).length;
});
const getRepitImgList = async () => {
  const { data } = await selectSimilartList({
    projectId: props.projectId,
    taskIdList: [props.id]
  });
  repitImgList.value = data || {};
  repitImgIds.value = Object.keys(repitImgList.value);
};
getRepitImgList();
const repeatPickurePerview = () => {
  createDialog({
    width: 1500,
    title: '图片重复关联项目',
    showClose: true,
    contentRender: () => {
      return (
        <div style="padding: 20px;">
          <RepeatPickure
            projectId={props.projectId}
            taskId={props.id}
            similarTaskIdList={repitImgList.value[props.id]}
          ></RepeatPickure>
        </div>
      );
    },
    beforeConfirm: async done => {
      done();
    }
  });
};

const auditShow = computed(() => {
  return props.canAudit && isAsp.value;
});

const compNames = computed(() => {
  return questionDetailComps(props.projectType);
});

function convertValuesToJsonArray(data: any[]): any[] {
  return data.map(item => {
    try {
      // 尝试将 values 字段解析为 JSON
      const parsedValues = JSON.parse(item.values);
      const parsedOptions = JSON.parse(item.optionJson);

      item.values = parsedValues;
      item.optionJson = parsedOptions;
    } catch (error) {
      // 如果解析失败，保持原样
    }
    return item;
  });
}
const taskDetail = ref<any>({});

const questionDetailInfo = computed(() => {
  return convertValuesToJsonArray(
    taskDetail.value?.questionnaireInFoDTOS || []
  );
});
// const body = document.body;

const showIndex = ref(0);
const emits = defineEmits(['auditOver', 'refresh']);

const onChangeImgUrl = url => {
  // 查找url在于picList
  const index = picList.value.findIndex(item => item === url);
  onChangeActive(index);
  showPreviewName.value = 'imgViewerShow';
};

const onChangeActive = index => {
  showIndex.value = index;
};
const onAudit = async status => {
  useTaskAudit({
    auditStatus: status,
    projectId: props.projectId,
    queryParams: {
      sceneType: props.projectType,
      taskRecordId: [props.id]
    },
    auditOver() {
      emits('auditOver', taskDetail.value?.nextTaskId);
    }
  });
};

const onMapRefresh = async () => {
  await taskRecordUpdateMap({
    taskRecordId: props.id,
    projectId: props.projectId,
    sceneType: props.projectType
  });
  getTaskDetail();
};

const onDiffMap = () => {
  showPreviewName.value = 'deefMapShow';
};

const picList = ref([]); //图片列表

const initPicList = async () => {
  picList.value = [];
  // 协定服务
  if (props.projectType === 19) {
    const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');

    questionDetailInfo.value[0].values.forEach(item => {
      // item.url 后缀为图片则push
      if (imageTypeReg.test(item.url)) {
        picList.value.push(item.url);
      }
    });
  } else {
    questionDetailInfo.value.forEach(item => {
      if (item.topicType === -3) {
        item.values && picList.value.push(item.values);
      }
      if (item.topicType === 20) {
        item.values && picList.value.push(item.values);
      }

      if (item.topicType === 13) {
        item.values &&
          item.values.forEach(item => {
            picList.value.push(item.url);
          });
      }
      if (item.topicType === 16) {
        item.values &&
          item.values.addressPicUrl &&
          picList.value.push(item.values.addressPicUrl);
      }
    });
  }
  if (props.projectType !== 17 && !picList.value.length) {
    showPreviewName.value = '';
  }
};

watch(
  () => showIndex.value,
  () => {
    showPreviewName.value = '';
    nextTick(() => {
      showPreviewName.value = 'imgViewerShow';
    });
  }
);

const getTaskDetail = async () => {
  const { data } = await taskRecordDetail({
    id: props.id,
    dataState: props.dataState,
    projectId: props.projectId,
    sceneType: props.projectType,
    searchVal: props.searchVal
  });
  taskDetail.value = data;
  initPicList();
};
getTaskDetail();
const onClose = () => {
  props.remove();
};
const handleEsc = event => {
  if (event.key === 'Escape') {
    onClose();
  }
};
onMounted(async () => {
  window.addEventListener('keydown', handleEsc);
});
onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc);
});
</script>
<style lang="scss" scoped>
::v-deep {
  .xrk-image-viewer__mask {
    opacity: 0;
  }
}
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: auto;
  &-right {
    z-index: 3000;
    position: absolute;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 16px 48px 16px rgba(0, 0, 0, 0.08),
      0px 12px 32px rgba(0, 0, 0, 0.12), 0px 8px 16px -8px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    width: 30%;
    height: 100%;
    right: 0;
    animation: slip_in 0.3s;
    &-header {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: #72767b;
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 22px 20px;
      border-bottom: 1px solid #c1c1c1;
    }
    &-main {
      height: calc(100vh - 160px);
      position: relative;
      overflow: auto;
      box-sizing: border-box;
      padding: 20px;
      &__reuqire {
        padding-bottom: 24px;
        border-bottom: 1px solid #f0f0f0;
        &-item {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          justify-content: space-between;
        }
      }
      &__info {
        margin-top: 24px;
      }
    }
    &-footer {
      text-align: right;
      height: 80px;
      background: #fff;
      border-top: 1px solid #c1c1c1;
      width: 100%;
      position: absolute;
      bottom: 0;
      padding: 25px 50px;
    }
  }
  &-left {
    width: 70%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    left: 0;
  }
}

/*右侧滑入*/
@keyframes slip_in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* 智能综合审核结论面板 */
.ai-verdict-panel {
  background: #fff;
  border: 1px solid #e2ddff;
  border-radius: 8px;
  overflow: hidden;
  margin: 16px 0;
}
.ai-vp-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 16px;
  background: linear-gradient(135deg, #6a5cff, #4a8de8);
  color: #fff;
}
.ai-vp-head-icon {
  font-size: 20px;
}
.ai-vp-head-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.04em;
}
.ai-vp-head-spacer {
  margin-left: auto;
}
.ai-vp-conclusion {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}
.ai-vp-body {
  padding: 16px;
}
.ai-vp-section-title {
  font-size: 12.5px;
  font-weight: 700;
  color: #e04848;
  margin: 14px 0 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ai-stage-row {
  /* flex 自适应：仅一个阶段卡时独占整行，两个时等分 */
  display: flex;
  gap: 12px;
  margin-bottom: 4px;
}
.ai-stage {
  flex: 1;
  min-width: 0;
  border: 1px solid #eee9ff;
  border-radius: 6px;
  padding: 12px;
  background: #faf9ff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.ai-stage-t {
  font-size: 12px;
  font-weight: 700;
  color: #5b4fd8;
  margin-bottom: 8px;
}
.ai-stage-sum {
  font-size: 12px;
  color: #4a5568;
  line-height: 1.6;
  margin-top: 6px;
}
.ai-stage-time {
  font-size: 11px;
  color: #aab6c9;
  margin-top: auto;
  padding-top: 7px;
}
.aia-pill {
  display: inline-block;
  padding: 3px 14px;
  border-radius: 12px;
  font-size: 12px;
}
.aia-pill.pass {
  background: #e8f7ee;
  color: #1f9d5b;
}
.aia-pill.reject {
  background: #fdeaea;
  color: #e04848;
}
.aia-pill.review {
  background: #fff7e6;
  color: #d98a00;
}
.ai-verdict {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 9px;
  font-size: 11.5px;
  font-weight: 700;
  border-radius: 11px;
  border: 1px solid transparent;
}
.ai-verdict-icon {
  font-size: 11px;
}
.ai-pass {
  background: rgba(46, 168, 102, 0.12);
  border-color: rgba(46, 168, 102, 0.45);
  color: #1f9d5b;
}
.ai-warn {
  background: rgba(245, 166, 35, 0.14);
  border-color: rgba(245, 166, 35, 0.5);
  color: #d98a00;
}
.ai-reject {
  background: rgba(232, 74, 74, 0.12);
  border-color: rgba(232, 74, 74, 0.45);
  color: #e04848;
}
.ai-reason-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ai-reason {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid gainsboro;
}
.ai-reason.ok {
  background: #eafaf1;
  border-color: #c7eed8;
}
.ai-reason-code {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  background: #fff;
  border: 1px solid gainsboro;
  border-radius: 4px;
  padding: 1px 6px;
  height: fit-content;
}
.ai-reason.ok .ai-reason-code {
  color: #1f9d5b;
  border-color: #b6e6c8;
}
/* 通过场景：绿底白勾方块 */
.ai-reason-check {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background: #1f9d5b;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ai-reason.ok .ai-reason-title {
  color: #1f9d5b;
}
.ai-reason-title {
  font-size: 12.5px;
  font-weight: 600;
  color: #2a3a55;
}
.ai-reason-desc {
  font-size: 12px;
  color: #6a7689;
  line-height: 1.55;
  margin-top: 3px;
}
</style>
